import { Metric } from "@/metrics/installationMetrics";

export const formatUnit = (unit: Metric["unit"] | string): string | undefined => {
  switch (unit) {
    case "percent":
      return "%"
    case "dollars":
      return "$"
    case "degree_Celsius":
      return "°C"
    case "number":
      return;
    default:
      return unit;
  }
}

const formatValueAndUnit = <ValueType>(
  value: ValueType,
  unit: Metric["unit"] | string,
  valueWrapper?: (value: ValueType) => any,
  unitWrapper?: (unit: string) => any
) => {
  const wrappedValue = valueWrapper ? valueWrapper(value) : value;

  const formattedUnit = formatUnit(unit);
  if (!formattedUnit) {
    return [wrappedValue]
  }

  const wrappedUnit = unitWrapper ? unitWrapper(formattedUnit) : formattedUnit;

  if (unit === "dollars" || unit === "$" || unit === "USD") {
    return [wrappedUnit, wrappedValue]
  } else {
    return [wrappedValue, wrappedUnit]
  }
}

export default formatValueAndUnit;
